import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
	children: ReactNode;
	className?: string;
}

const CustomTag: React.FC<Props> = ({ children, className }) => {
	return <div className={classNames('custom-tag', className)}>{children}</div>;
};

export default CustomTag;
